import * as React from "react"
const SvgPin = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M16 5.286v7l1.7 1.7a1 1 0 0 1 .3.725v.575q0 .424-.288.712a.97.97 0 0 1-.712.288h-4v5.85a.97.97 0 0 1-.287.712.97.97 0 0 1-.713.288.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712v-5.85H7a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712v-.575q0-.2.075-.388a1 1 0 0 1 .225-.337l1.7-1.7v-7a.97.97 0 0 1-.713-.288A.97.97 0 0 1 7 4.286a.97.97 0 0 1 .287-.713A.97.97 0 0 1 8 3.286h8q.424 0 .712.287.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288m-7.15 9h6.3L14 13.136v-7.85h-4v7.85z" />
  </svg>
)
export default SvgPin
